"use client";

import { cn } from '../lib/utils'
import React, { PropsWithChildren } from 'react'
type DashboardContentWrapperProps = PropsWithChildren & {
    /**
     * @default 'overflow-y-auto p-dashboard pt-5 pb-20 md:pb-10 md:pt-8'
     */
    className?: string,
}

function DashboardContentWrapper({ children, className }: DashboardContentWrapperProps) {

    return (
        <div
            id='dashboard-content-wrapper-id'
            className={cn(
                'outline-none focus-visible:outline-none overflow-y-auto px-dashboard pt-5 pb-20 md:pb-10'
            )}
        >
            <div className={cn('w-full', className)}>
                {children}
            </div>
        </div>
    )
}

export default DashboardContentWrapper
